import {Component, OnInit} from '@angular/core';
import {AuthenticationService} from '../../../authenticationModule/services/authentication.service';
import {SelectItem} from 'primeng/api';
import {RequestHistoricalData} from '../../../generated/model/request-historical-data';
import * as _ from 'lodash';
import {EtreeService} from '../../../services/etree.service';
import {HistEtree} from '../../../models/hist-etree';
import {HistPop} from '../../../models/hist-pop';
import {formatDate} from '@angular/common';
import {HistoryRequestService} from '../../../generated/api/history-request.service';
import {BaseClientComponent} from '../../base-client.component';
import {UtilsService} from '../../../appSharedModule/services/utils.service';
import {HttpClient} from '@angular/common/http';

@Component({
  selector: 'app-request-historical-data',
  templateUrl: './request-historical-data.component.html',
  styleUrls: ['./request-historical-data.component.scss']
})
export class RequestHistoricalDataComponent extends BaseClientComponent implements OnInit {

  histEtrees: HistEtree[];
  timeZonesItems: SelectItem[];
  etreeItems: SelectItem[];
  popItems: SelectItem[];
  requestHistoricalData: RequestHistoricalData;
  loading = false;
  requestIsBeingProcessedAlertMessage = false;
  requestError = false;
  minStartDate: Date | undefined;
  maxStartDate: Date | undefined;
  minEndDate: Date | undefined;
  maxEndDate: Date | undefined;

  constructor(public utilsService: UtilsService,
              public authenticationService: AuthenticationService,
              private historyRequestService: HistoryRequestService,
              private etreeService: EtreeService,
              protected http: HttpClient) {
    super();
  }

  ngOnInit() {
    this.initCalendarLimits();
    this.loading = true;
    this.requestHistoricalData = new RequestHistoricalData();
    const response$ = this.authenticationService.waitForAuthenticationThenLaunch(() => {
      this.initializeEtreeItems();
    });
    this.subscriptions.push(response$);
    this.initializeTimeZonesItems();
  }

  private initCalendarLimits() {
    this.minStartDate = new Date('2021-10-01');
    this.minEndDate = new Date('2021-10-01');
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    this.maxStartDate = yesterday;
    this.maxEndDate = yesterday;
  }

  public changeStartDate() {
    this.minEndDate = this.requestHistoricalData.start;
    const date = new Date(this.requestHistoricalData.start);
    if (this.requestHistoricalData.start.getMonth() > 10) {
      date.setMonth(this.requestHistoricalData.start.getMonth() + 2 - 12);
      date.setFullYear(this.requestHistoricalData.start.getFullYear() + 1);
    } else {
      date.setMonth(this.requestHistoricalData.start.getMonth() + 2);
    }
    this.maxEndDate = date < this.maxEndDate ? date : this.maxEndDate;
  }

  public changeEndDate() {
    this.maxStartDate = this.requestHistoricalData.stop;
    const date = new Date(this.requestHistoricalData.stop);
    if (this.requestHistoricalData.stop.getMonth() < 2) {
      date.setMonth(this.requestHistoricalData.stop.getMonth() + 12 - 2);
      date.setFullYear(this.requestHistoricalData.stop.getFullYear() - 1);
    } else {
      date.setMonth(this.requestHistoricalData.stop.getMonth() - 2);
    }
    this.minStartDate = date > this.minStartDate ? date : this.minStartDate;
  }

  private initializeEtreeItems() {
    const etreeItems = [];
    this.etreeService.getEtrees().subscribe(
      res => {
        this.histEtrees = res.filter(etree => etree.vvlanId);
        _.forEach(this.histEtrees, (etree: HistEtree) => {
          etreeItems.push({
            label: etree.companyName + ' - Injection: ' + etree.injection + ' - Xconnect: '
              + etree.xConnect + ' - E-tree Ref: ' + etree.etreeRef,
            value: etree.connectionPointId
          });
        });
        etreeItems.sort((a, b) => (
          a.label.localeCompare(b.label)
        ));
        if (etreeItems.length !== 0) {
          this.requestHistoricalData.connectionPointId = etreeItems[0].value;
          this.initializePopItems(etreeItems[0].value);
        }
        this.etreeItems = etreeItems;
      }
    );
  }

  initializePopItems(code: string) {
    this.popItems = [];
    _.forEach(this.histEtrees.find(x => x.connectionPointId === code).listeningPop, (listeningPop: HistPop) => {
      this.popItems.push({
        label: listeningPop.name + ' - ' + listeningPop.shortname,
        value: listeningPop.shortname
      });
      this.loading = false;
    });
    this.requestHistoricalData.listeningPop = this.popItems[0].value;
  }

  private initializeTimeZonesItems() {
    this.timeZonesItems = [
      {label: 'UTC', value: 'UTC'},
      {label: 'America/Chicago', value: 'CHI'},
      {label: 'America/New_York', value: 'NYC'},
      {label: 'Europe/Berlin', value: 'BER'},
      {label: 'Asia/Tokyo', value: 'Tokyo'},
    ];
    this.requestHistoricalData.timezone = this.timeZonesItems[0].value;
  }

  getUserCurrent() {
    return this.authenticationService.getUserCurrent();
  }

  onSubmit(historyRequestForm) {
    this.requestIsBeingProcessedAlertMessage = false;
    if (!historyRequestForm.valid) {
      return;
    } else {
      this.loading = true;
      this.addHistoryRequest();
      return false;
    }
  }

  private addHistoryRequest() {
    const selectedEtree = this.histEtrees.find(x => x.connectionPointId === this.requestHistoricalData.connectionPointId);
    this.requestHistoricalData.name = this.popItems.find(x => x.value === this.requestHistoricalData.listeningPop).label;
    const newHistoryRequest = new RequestHistoricalData();
    newHistoryRequest.companySugarId = this.requestHistoricalData.companySugarId;
    newHistoryRequest.name = selectedEtree.etreeRef + ' - from ' + selectedEtree.injection
      + ' to ' + this.requestHistoricalData.name;
    newHistoryRequest.frompop = selectedEtree.injection;
    newHistoryRequest.topop = this.requestHistoricalData.listeningPop;
    newHistoryRequest.start = this.updateDateByTimezone(this.requestHistoricalData.timezone,
      this.requestHistoricalData.start);
    newHistoryRequest.stop = this.updateDateByTimezone(this.requestHistoricalData.timezone,
      this.requestHistoricalData.stop);
    newHistoryRequest.etreeId = selectedEtree.etreeId;
    this.requestIsBeingProcessedAlertMessage = false;
    this.requestError = false;
    this.historyRequestService.postHistoryRequestCollection(newHistoryRequest).subscribe({
        next: () => {
          this.requestIsBeingProcessedAlertMessage = true;
          this.requestError = false;
          this.loading = false;
        },
        error: () => {
          this.requestError = true;
          this.requestIsBeingProcessedAlertMessage = false;
          this.loading = false;
        }
      }
    );
  }

  updateDateByTimezone(timezone: string, date: Date): Date {
    let convertedDate;
    switch (timezone) {
      case 'CHI': {
        // convertedDate = formatDate(date, 'yyyy-MM-ddTHH:mm', 'en-us', '+5');
        convertedDate = formatDate(date, 'yyyy-MM-ddTHH:mm', 'en-us', '+6');
        break;
      }
      case 'NYC': {
        // convertedDate = formatDate(date, 'yyyy-MM-ddTHH:mm', 'en-us', '+4');
        convertedDate = formatDate(date, 'yyyy-MM-ddTHH:mm', 'en-us', '+5');
        break;
      }
      case 'BER': {
        // convertedDate = formatDate(date, 'yyyy-MM-ddTHH:mm', 'en-us', '-2');
        convertedDate = formatDate(date, 'yyyy-MM-ddTHH:mm', 'en-us', '-1');
        break;
      }
      case 'Tokyo': {
        // convertedDate = formatDate(date, 'yyyy-MM-ddTHH:mm', 'en-us', '-9');
        convertedDate = formatDate(date, 'yyyy-MM-ddTHH:mm', 'en-us', '-8');
        break;
      }
      default: {
        convertedDate = formatDate(date, 'yyyy-MM-ddTHH:mm', 'en-us');
        break;
      }
    }
    return convertedDate;
  }
}


